const messages = {
  dashboard: {
    title: "{name} Dashboard",
    extraTitle: "WHOLESALER-DASHBOARD",
    description:
      "Herzlichen willkommen auf Ihrem Dashboard. Hier können Sie aktuelle Kennzahlen und teilnehmende Betriebe aus Ihrer Kundschaft einsehen.",
    overview: {
      title: "Übersicht teilnehmende Kunden",
      description:
        "Betriebe, die sich bei BRIDGESTONE PLUS mit angemeldet haben und die wir über die Kundennummer Ihren Unternehmen zuordnen können.",
      month: "Neu diesen Monat",
      year: "Neu dieses Jahr",
      all: "Gesamt",
    },
    credits: {
      title: "Punktegutschriften {name}",
      description:
        "Prämienpunkte, die teilnehmenden Betrieben aufgrund der von Ihnen hochgeladenen Absatzzahlen zugewiesen haben. In dieser Ansicht sind reguläre Punkte ohne Sonderaktionen dargestellt.",
      month: "Letzter Monat",
      year: "Aktuelles Jahr",
      prev_year: "Gesamt",
      allDealers: "Alle Händlerpunkte",
    },
    details: {
      title: "Teilnehmende Kunden im Detail",
      description:
        'Nachfolgend sind die Betriebe aufgeführt, die sich mit einer {name} Kundennummer auf BRIDGESTONE <span class="text-danger">PLUS</span> registriert haben und die Ihnen als Zuständigem/r zugewiesen sind. Nutzen Sie einfach Sortierfunktionen für eine andere Reifenfolge oder die Suchmaske.',
    },
    lastImport:
      'Letzter Import von Absatzzahlen: <br/> <span class="text-danger">{date}</span>',
    loadMore: "Weitere 20 händler laden",
    tyres: {
      title: "Reifen",
      description: "Bon Programmteilnehmern gekaufte Reifen",
    },
  },
};

export default {
  messages,
};
